import React from "react";
import { motion } from "framer-motion";

const INDUSTRIES = [
  { n: "01", name: "Oil & Gas", desc: "Upstream, midstream and downstream material supply — refinery turnarounds to pipeline builds.", img: "https://images.pexels.com/photos/15893881/pexels-photo-15893881.jpeg" },
  { n: "02", name: "Construction", desc: "General and specialty contractors sourcing structural, mechanical and jobsite materials.", img: "https://images.pexels.com/photos/11973740/pexels-photo-11973740.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { n: "03", name: "Energy & Power", desc: "Piping, valves and fasteners for power generation and renewable infrastructure.", img: "https://images.pexels.com/photos/11347815/pexels-photo-11347815.jpeg" },
  { n: "04", name: "Marine & Industrial", desc: "Fabrication shops, marine facilities and plant maintenance procurement support.", img: "https://images.unsplash.com/photo-1538474705339-e87de81450e8" },
];

export const Industries = () => {
  return (
    <section id="industries" className="relative py-24 md:py-36 bg-background" data-testid="industries">
      <div className="max-w-[1500px] mx-auto px-5 md:px-10">
        <div className="mb-14 md:mb-20 max-w-2xl">
          <span className="font-mono-tech text-xs tracking-[0.3em] uppercase text-primary flex items-center gap-3">
            <span className="inline-block w-10 h-px bg-accent" /> Industries Served
          </span>
          <h2 className="font-display font-extrabold uppercase tracking-tight text-4xl md:text-6xl mt-6 leading-[0.95] text-foreground">
            Fields we keep supplied
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-px bg-border">
          {INDUSTRIES.map((ind, i) => (
            <motion.div
              key={ind.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: (i % 2) * 0.08 }}
              className="group relative bg-background overflow-hidden h-[360px] md:h-[440px] flex items-end p-8"
              data-testid={`industry-${ind.n}`}
            >
              <div className="absolute inset-0 z-0">
                <img src={ind.img} alt={ind.name} className="w-full h-full object-cover img-grayscale opacity-40 group-hover:opacity-60 group-hover:scale-105 transition-all duration-[800ms]" />
                <div className="absolute inset-0 bg-gradient-to-t from-background via-background/80 to-background/20" />
              </div>
              <div className="relative z-10">
                <span className="font-mono-tech text-sm text-accent">{ind.n}</span>
                <h3 className="font-display font-extrabold uppercase text-3xl md:text-5xl tracking-tight text-foreground mt-2 leading-none">
                  {ind.name}
                </h3>
                <p className="mt-4 max-w-md text-base text-steel leading-relaxed">{ind.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
